import { SVGProps } from 'react'

export function WarningOutlineIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 28 28" {...props}>
      <path
        d="M15.5002 10V19H13.5002V10H15.5002ZM14.5002 21C13.7002 21 13.0002 21.7 13.0002 22.5C13.0002 23.3 13.7002 24 14.5002 24C15.3002 24 16.0002 23.3 16.0002 22.5C16.0002 21.7 15.3002 21 14.5002 21ZM28.2002 27.1C27.8002 27.7 27.2002 28 26.5002 28H2.50017C1.80017 28 1.20017 27.7 0.800172 27.1C0.400172 26.5 0.400172 25.8 0.700172 25.2L12.7002 1.2C13.0002 0.4 13.7002 0 14.5002 0C15.3002 0 16.0002 0.4 16.3002 1.1L28.3002 25.1C28.6002 25.8 28.6002 26.5 28.2002 27.1ZM26.5002 26L14.5002 2L2.50017 26H26.5002Z"
        fill="currentColor"
      />
    </svg>
  )
}
